import React, { useEffect, useState } from 'react';
import VignetteVan from '../components/VignetteVan';
import supabase from '../utils/supabaseClient';
import { Van } from '../types/van';

const VanBooking: React.FC = () => {
  const [vans, setVans] = useState<Van[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchVans = async () => {
      const { data, error } = await supabase
        .from('vans')
        .select('*')
        .order('ordre');

      if (error) {
        setError('Impossible de charger les vans. Veuillez réessayer.');
      } else {
        setVans(data ?? []);
      }
      setLoading(false);
    };

    fetchVans();
  }, []);

  return (
    <div className="bg-gradient-to-b from-blue-50 to-blue-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos Vans Disponibles
          </h1>
          <p className="text-xl text-gray-600">
            Découvrez notre flotte de vans aménagés pour vos aventures
          </p>
        </div>

        {loading && (
          <div className="text-center text-gray-500 py-12">Chargement...</div>
        )}

        {error && (
          <div className="text-center text-red-500 py-12">{error}</div>
        )}

        <div className="flex flex-col gap-8">
          {vans.map((van) => (
            <VignetteVan
              key={van.id}
              image={van.image_url}
              nom={van.nom}
              modele={van.modele}
              nombreCouchages={van.nombre_couchages}
              nombrePlaces={van.nombre_places}
              motorisation={van.motorisation}
              options={van.options}
              plateformes={[
                { nom: van.nom_plateforme1, lien: van.lien_plateforme1, type: van.type_plateforme1 ?? 'amenage' },
                { nom: van.nom_plateforme2, lien: van.lien_plateforme2, type: van.type_plateforme2 ?? 'amenage' },
                ...(van.nom_plateforme3 ? [{ nom: van.nom_plateforme3, lien: van.lien_plateforme3, type: van.type_plateforme3 ?? 'amenage' }] : []),
                ...(van.nom_plateforme4 ? [{ nom: van.nom_plateforme4, lien: van.lien_plateforme4, type: van.type_plateforme4 ?? 'amenage' }] : []),
              ]}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default VanBooking;
